import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    Optional,
    Output,
    SimpleChanges
} from "@angular/core";
import {FUIAbstractControl} from "../framework/abstract-control";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIOptionsService} from "../framework/options.service";

@Component({
    providers: [
        {
            multi: true,
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIMoreControlComponent)
        },
        FUIOptionsService
    ],
    selector: "fui-more-control",
    templateUrl: "./more-control.component.html",
    standalone: false
})
export class FUIMoreControlComponent extends FUIAbstractControl implements OnChanges {
    @Input() public labelField: string;
    @Input() public valueField: string;
    @Input() public icon: string;
    @Input() public iconSize: number = 16;

    private _options: Array<any>;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext,
                private optionsService: FUIOptionsService) {
        super(changeDetectorRef);
    }

    /**
     *
     * @returns {Array<any>}
     */
    get options(): Array<any> {
        return this._options;
    }

    /**
     *
     * @param {Array<any>} options
     */
    @Input()
    set options(options: Array<any>) {
        this._options = options;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["valueField"]) {
            this.optionsService.valueField = this.valueField;
        }
    }
}
